module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/chunk-callback-order/a.js
 ** module id = 3
 ** module chunks = 2 3
 **/